import React from 'react';
import CheckIcon from '../Own/ui/CheckIcon';
import CommentsListImg from 'assets/img/list_comments.png'
import NotificationImg from 'assets/img/android_notification.png'

const FeaturesSection = () => {

    return (
        <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 w-full">
            <div className='w-full flex flex-col md:flex-row items-center'>
                <div className='w-full md:w-8/12'>
                    <div>
                        <div className='flex items-center mb-4'>
                            <h2 className='text-primary text-3xl font-semibold'>
                                @maplistbot
                                <span className='ml-2 font-bold font-italic'>
                                    create a list
                                </span>
                            </h2>
                            <div className='mt-1'>
                                <span className="bg-blue-100 text-blue-800 text-xs font-medium ml-2 px-2.5 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">
                                    FREE
                                </span>
                                <span className="bg-green-100 text-green-800 text-xs font-medium ml-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                                    PRO
                                </span>
                            </div>
                        </div>
                        <p>
                            Answer with this text to any thread to create a Google Maps list with the places recommended in it.
                            <br />
                            Give MapList some minutes and you will get a reply with the link to your new list.
                        </p>
                        <h3 className="inline-flex items-center mt-4 font-bold">
                            <span className="bg-green-100 text-green-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                                PRO
                            </span>
                            only with MapList Pro:
                        </h3>
                        <>
                            <div className='flex flex-row my-3 items-center'>
                                <CheckIcon />
                                <span className='ml-1'>
                                    Unlimited number of places in the list (Free limited to 10 places)
                                </span>
                            </div>
                            <div className='flex flex-row my-3 items-center'>
                                <CheckIcon />
                                <span className='ml-1'>
                                    Personalized notes for each place based on the comments in the thread
                                </span>
                            </div>
                            <div className='flex flex-row my-3 items-center'>
                                <CheckIcon />
                                <span className='ml-1'>
                                    Private invitation link to edit the list
                                </span>
                            </div>
                        </>

                    </div>
                    <div className='w-full mt-16'>
                        <div className='flex items-center mb-4'>
                            <h2 className='text-primary text-3xl font-semibold'>
                                @maplistbot
                                <span className='ml-2 font-bold font-italic'>
                                    {'create a {keyword} list'}
                                </span>
                            </h2>
                            <div className='mt-1'>
                                <span className="bg-green-100 text-green-800 text-xs font-medium ml-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                                    PRO
                                </span>
                            </div>
                        </div>
                        <p>
                            Add a keyword when creating a new list to filter specific places for your new list.
                            <br />
                            Just replace <span className='font-italic'>{'{keyword}'}</span> with the kind of places you want to be included.
                            <br />
                            Example: answer with "@maplistbot create a hotel list" to add only hotels to you new Google Maps list.
                        </p>
                    </div>
                </div>
                <div className='w-full md:w-4/12 mt-8 md:mt-0'>
                    <img className='w-full' src={CommentsListImg} />
                </div>
            </div>
            <div className='w-full mt-16 flex flex-col-reverse md:flex-row items-center'>
                <div className='w-full md:w-4/12 mt-8 md:mt-0'>
                    <img className='w-full' src={NotificationImg} />
                </div>
                <div className='w-full md:w-8/12 ml-0 md:ml-32'>
                    <div className='flex items-center mb-4'>
                        <h2 className='text-primary text-3xl font-semibold'>
                            @maplistbot
                            <span className='ml-2 font-bold font-italic'>
                                {'add to {keyword} list'}
                            </span>
                        </h2>
                        <div className='mt-1'>
                            <span className="bg-green-100 text-green-800 text-xs font-medium ml-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                                PRO
                            </span>
                        </div>
                    </div>
                    <p>
                        Answer to a tweet with this command to add one or many places to an existing list.
                        <br />
                        Just replace <span className='font-italic'>{'{keyword}'}</span> with the name of the city, country or any other word in the title of the list you want to modify.
                        <br />
                        Example: answer with "@maplistbot add to brunch list" to add a new place to your "Recommended brunch places" list.
                    </p>
                    {/*
                <h3 className="inline-flex items-center mt-4 font-bold">
                    Tip:
                    <span className='font-normal ml-1'>
                        To use any of your already existing Google Maps list you just have to invite maplistbot@gmail.com to edit them.
                    </span>
                </h3>
                <p>
                    Learn how to do it here:
                </p>
                */}
                </div>
            </div>
        </div>
    );
};

export default FeaturesSection;